<template>
  <div :class="{ sticky: isSticky }">
    <div v-if="isMobile" class="nav-drawer-button-container">
      <v-btn icon @click="drawer = !drawer">
        <v-icon large>{{ icons.mdiMenu }}</v-icon>
      </v-btn>
    </div>
    <v-navigation-drawer
      v-model="drawer"
      app
      fixed
      clipped
      right
      temporary
      class="nav-drawer-container"
    >
      <v-app-bar flat dense transparent fixed>
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon @click="drawer = false">
          <v-icon class="close-button" large>{{ icons.mdiClose }}</v-icon>
        </v-app-bar-nav-icon>
      </v-app-bar>
      <v-list nav dense class="nav-list" :ripple="false">
        <v-list-item-group class="pl-5 pt-10">
          <div class="nav-list-item" v-for="(item, index) in loggedOutItems">
            <v-list-item-content>
              <v-list-item-title>
                <router-link
                  class="mobile-menu-item"
                  :href="item.href"
                  :to="!!item.to ? item.to : item.href"
                  :target="item.target"
                  :key="index"
                  exact
                >
                  {{ item.title }}
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { mdiMenu, mdiClose } from "@mdi/js";
export default {
  name: "NavDrawer",
  props: {
    isSticky: {
      required: true,
      default: false,
      type: Boolean,
    },
    windowWidth: {
      required: true,
      default: window.innerWidth,
      type: Number,
    },
  },
  data() {
    return {
      drawer: false,
      isArticle: false,
      icons: {
        mdiMenu: mdiMenu,
        mdiClose: mdiClose,
      },
    };
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice() || this.windowWidth <= 1057;
    },
    loggedOutItems() {
      return [
        {
          title: "Home",
          to: "/",
        },
        {
          title: "How it works",
          to: "/how-it-works",
        },
        {
          title: "Our Solutions",
          to: "/our-solutions",
        },
        {
          title: "Calculators",
          to: "/calculators",
        },
        {
          title: "FAQs",
          to: "/faqs",
        },
        {
          title: "Articles",
          to: "/articles",
        },
      ];
    },
  },
  created() {
    this.handleNavDrawerButtonClass(this.$route.name);
  },
  methods: {
    handleNavDrawerButtonClass(route) {
      this.isArticle = route === "Article";
    },
  },
  watch: {
    $route(to, from) {
      this.handleNavDrawerButtonClass(to.name);
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-drawer-container {
  max-height: 100% !important;
  width: calc(100dvw - 100px) !important;
  z-index: 100;
}

.sticky {
  z-index: 12;
  margin-left: 90px;
  .nav-drawer-button-container {
    position: static !important;
    display: flex;
    align-items: center;
    justify-content: center;

    .v-icon {
      color: black;
    }
  }
}
.nav-drawer-button-container {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 35px;
  left: 90px;
  z-index: 12;

  .v-icon {
    color: white;
  }
  &.isArticle {
    .v-icon {
      color: black !important;
    }
  }
}

.mobile-menu-item {
  text-decoration: none;
  margin-right: 25px;
  color: #282828 !important;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.1px;
  &.router-link-active {
    font-weight: 600;
    color: #50b848 !important;
  }
}
.v-app-bar {
  box-shadow: none;
}

.close-button {
  color: black !important;
}
.v-navigation-drawer .v-app-bar {
  background-color: transparent !important;
  box-shadow: none;
}

.nav-list-item {
  background-color: transparent !important;
}

.nav-list-item:hover {
  background-color: transparent !important;
}

.v-list-item.v-list-item--active {
  background-color: transparent !important;
}

@media screen and (min-width: 0px) and (max-width: 400px) {
  .nav-drawer-button-container {
    left: 75px !important;
  }
}
</style>
